import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { TimelineItemModel } from '@bayclubs/court-booking-employee-api';
import { CourtEventTimelineTrigger } from '@shared-models/shared-models.module';

@Component({
    selector: 'app-court-event-timeline',
    templateUrl: './court-event-timeline.component.html',
    styleUrls: ['./court-event-timeline.component.scss'],
    standalone: false
})
export class CourtEventTimelineComponent implements OnInit {
    private readonly by = this.translate.instant('CourtEventDetails.By');
    private readonly bcStaff: string = this.translate.instant('CourtEventDetails.BcStaff');
    private readonly system: string = this.translate.instant('CourtEventDetails.System');

    @Input() timelines: Array<TimelineItemModel>;

    constructor(private translate: TranslateService) { }

    ngOnInit(): void { }

    getDescription(item: TimelineItemModel) {
        const triggerCode: string = item.triggerType.code;

        switch (triggerCode) {
            case CourtEventTimelineTrigger.blockedSlotCreated.code:
                return this.blockedSlotCreatedDescription(item);
            case CourtEventTimelineTrigger.blockedSlotStatusChanged.code:
                return this.courtBookingPlayerStatusChangedDescription(item);
            case CourtEventTimelineTrigger.blockedSlotEdited.code:
                return this.blockedSlotEditedDescription(item);
            case CourtEventTimelineTrigger.courtBookingCreated.code:
                return this.courtBookingCreatedDescription(item);
            case CourtEventTimelineTrigger.courtBookingStatusChanged.code:
                return this.courtBookingStatusChangedDescription(item);
            case CourtEventTimelineTrigger.courtBookingEdited.code:
                return this.courtBookingEditedDescription(item);
            case CourtEventTimelineTrigger.groupClassCreated.code:
                return this.groupClassCreatedDescription(item);
            case CourtEventTimelineTrigger.groupClassStatusChanged.code:
                return this.groupClassStatusChangedDescription(item);
            case CourtEventTimelineTrigger.courtBookingPlayerCreated.code:
                return this.courtBookingPlayerCreatedDescription(item);
            case CourtEventTimelineTrigger.courtBookingPlayerStatusChanged.code:
                return this.courtBookingPlayerStatusChangedDescription(item);
        }
    }

    private blockedSlotCreatedDescription(item: TimelineItemModel) {
        return this.by + item.createdByEmployeeName + this.bcStaff;
    }

    //"edited "  is temporary solution. In next release we will change it
    private blockedSlotEditedDescription(item: TimelineItemModel) {
        return "edited " + this.by + item.createdByEmployeeName + this.bcStaff;
    }

    private blockedSlotStatusChangedDescription(item: TimelineItemModel) {
        return this.by + item.createdByEmployeeName + this.bcStaff;
    }

    private courtBookingCreatedDescription(item: TimelineItemModel) {
        return this.by + this.getByWho(item);
    }

    private courtBookingStatusChangedDescription(item: TimelineItemModel) {
        return this.by + this.getByWho(item);
    }

    private courtBookingEditedDescription(item: TimelineItemModel) {
        return "edited " + this.by + this.getByWho(item);
    }

    private groupClassCreatedDescription(item: TimelineItemModel) {
        return this.by + this.bcStaff;
    }

    private groupClassStatusChangedDescription(item: TimelineItemModel) {
        return this.by + this.bcStaff;
    }

    private courtBookingPlayerCreatedDescription(item: TimelineItemModel) {
        return item.playerFullName + ' ' + this.by + this.getByWho(item);
    }

    private courtBookingPlayerStatusChangedDescription(item: TimelineItemModel) {
        return item.playerFullName + ' ' + this.by + this.getByWho(item);
    }

    private getByWho(item: TimelineItemModel) {
        if (item.createdByMemberName) {
            return item.createdByMemberName;
        }

        if (item.createdByEmployeeName) {
            return item.createdByEmployeeName + this.bcStaff;
        }
        return this.system;
    }
}
